import React from 'react';
import {map as _map} from 'lodash';
import classnames from 'classnames';

import './style.scss';

const formatInterval = (interval, bounds) => {
	bounds = bounds || [true, false];
	return (
		(bounds[0] ? '[' : '(') +
		interval[0] +
		', ' +
		interval[1] +
		(bounds[1] ? ']' : ')')
	);
};

export const Symbol = props => {
	return (
		<div className="eo4sdDrrInsarVietnam20-legend-symbol">
			<div
				style={{
					background: props.style.fill,
					borderColor: props.style.outlineColor,
					borderWidth: props.style.outlineWidth,
				}}
				className="eo4sdDrrInsarVietnam20-legend-symbol-circle"
			/>
		</div>
	);
};

export const IntervalsLegendItemColor = props => {
	return (
		<div className="eo4sdDrrInsarVietnam20-legend-intervals-item">
			<div style={{background: props.color}} />
			<span>{props.value}</span>
		</div>
	);
};

export const IntervalsLegendItemOutlineWidth = props => {
	return (
		<div className="eo4sdDrrInsarVietnam20-legend-intervals-item">
			<div style={{height: props.outlineWidth, background: props.fill}} />
			<span>{props.value}</span>
		</div>
	);
};

export const ValuesLegendItem = props => {
	return (
		<div className="eo4sdDrrInsarVietnam20-legend-values-item">
			<div style={{background: props.color}} />
			<span>{props.value}</span>
		</div>
	);
};

export const Intervals = props => {
	return (
		<div className="eo4sdDrrInsarVietnam20-legend-section-content">
			{props.classes.map((cls, i) => {
				if (props.styleProperty === 'outlineWidth') {
					return (
						<IntervalsLegendItemOutlineWidth
							key={i}
							value={
								cls.name || formatInterval(cls.interval, cls.intervalBounds)
							}
							outlineWidth={cls.outlineWidth}
							fill={cls.outlineColor || props.baseColor}
						/>
					);
				} else {
					return (
						<IntervalsLegendItemColor
							key={i}
							value={
								cls.name || formatInterval(cls.interval, cls.intervalBounds)
							}
							color={cls.fill}
						/>
					);
				}
			})}
			{props.noData ? (
				<IntervalsLegendItemColor value="No data" color={props.noData} />
			) : null}
		</div>
	);
};

export const IntervalsLine = props => {
	const lineClasses = classnames(
		'eo4sdDrrInsarVietnam20-legend-intervals-line-colors',
		{
			'longer-tails': props.longerTails,
		}
	);

	return (
		<div className="eo4sdDrrInsarVietnam20-legend-section-content">
			<div className="eo4sdDrrInsarVietnam20-legend-intervals-line-content">
				<div className="eo4sdDrrInsarVietnam20-legend-intervals-line">
					<div className={lineClasses}>
						{props.classes.map((cls, i) => (
							<div
								key={i}
								title={
									cls.name
										? cls.name
										: formatInterval(cls.interval, cls.intervalBounds)
								}
								style={{background: cls[props.styleProperty]}}
							/>
						))}
					</div>
					<div className="eo4sdDrrInsarVietnam20-legend-intervals-labels">
						<span>
							{props.classes[0].name
								? props.classes[0].name
								: props.classes[0].interval[0]}
						</span>
						<span>
							{props.classes[props.classes.length - 1].name
								? props.classes[props.classes.length - 1].name
								: props.classes[props.classes.length - 1].interval[1]}
						</span>
					</div>
				</div>
				{props.noData ? (
					<div className="eo4sdDrrInsarVietnam20-legend-intervals-line-no-data">
						<div style={{background: props.noData}} />
						<span>No data</span>
					</div>
				) : null}
			</div>
		</div>
	);
};

export const ValuesByColor = props => {
	return (
		<div className="eo4sdDrrInsarVietnam20-legend-section-content">
			{_map(props.data, (item, key) => {
				return (
					<ValuesLegendItem
						key={key}
						value={item.name || key}
						color={item.fill}
					/>
				);
			})}
			{props.noData ? (
				<ValuesLegendItem
					value={props.noDataTitle || 'No data'}
					color={props.noData}
				/>
			) : null}
		</div>
	);
};

export const ValuesBySize = props => {
	const baseStyle = props.style;

	return (
		<div className="eo4sdDrrInsarVietnam20-legend-section-content">
			{_map(props.data, (style, key) => {
				return (
					<div
						className="eo4sdDrrInsarVietnam20-legend-values-by-size-item"
						key={key}
					>
						<div className="symbol">
							<div
								style={{
									width: 2 * style.size,
									height: 2 * style.size,
									borderRadius: (2 * style.size) / 2,
									borderWidth: baseStyle.outlineWidth,
									borderColor: baseStyle.outlineColor,
									background: baseStyle.fill,
								}}
							/>
						</div>
						<span>{key}</span>
					</div>
				);
			})}
		</div>
	);
};

export const SectionHeader = ({title, subtitle}) => {
	return (
		<div className="eo4sdDrrInsarVietnam20-legend-section-header">
			<div className="title">{title}</div>
			<div className="subtitle">{subtitle}</div>
		</div>
	);
};
